import { Model } from "pinia-orm";

export default class Supervision extends Model {
  static entity = "supervisions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      project: this.attr(null),
      projectUuid: this.string(""),
      isActive: this.boolean(true),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
    };
  }
}
